var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-tabs",
        {
          key: _vm.tabKey,
          attrs: { left: "" },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [
          _c("v-tab", { attrs: { id: "miTab0", href: "#tab-1" } }, [
            _vm._v("Registro Actividades")
          ]),
          _c(
            "v-tab",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mostrarAlertas,
                  expression: "mostrarAlertas"
                }
              ],
              attrs: { id: "miTab1", href: "#tab-2" }
            },
            [_vm._v("Alertas")]
          ),
          _c(
            "v-tab",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.accionComunicaciones.visible,
                  expression: "accionComunicaciones.visible"
                }
              ],
              attrs: { id: "miTab2", href: "#tab-3" }
            },
            [_vm._v("Comunicaciones")]
          ),
          _c(
            "v-tab",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mostrarMantenimiento && _vm.valideSubDomain,
                  expression: "mostrarMantenimiento && valideSubDomain"
                }
              ],
              attrs: { id: "miTab3", href: "#tab-4" }
            },
            [_vm._v("Mantenimiento Preventivo")]
          ),
          _c(
            "v-tab",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.mostrarMantenimiento && _vm.valideSubDomain,
                  expression: "mostrarMantenimiento && valideSubDomain"
                }
              ],
              attrs: { id: "miTab4", href: "#tab-5" }
            },
            [_vm._v("Mantenimiento Correctivo")]
          )
        ],
        1
      ),
      _c(
        "v-flex",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabModel === "tab-1",
              expression: "tabModel === 'tab-1'"
            }
          ],
          attrs: { md12: "", sm12: "", xs12: "" }
        },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [_c("ActividadesDetalleGrid")],
            1
          )
        ],
        1
      ),
      _c(
        "v-flex",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabModel === "tab-2",
              expression: "tabModel === 'tab-2'"
            }
          ],
          attrs: { md12: "", sm12: "", xs12: "" }
        },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [_c("AlertasDetalleGrid")],
            1
          )
        ],
        1
      ),
      _c(
        "v-flex",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabModel === "tab-3",
              expression: "tabModel === 'tab-3'"
            }
          ],
          attrs: { md12: "", sm12: "", xs12: "" }
        },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [_c("ComunicacionesGrid")],
            1
          )
        ],
        1
      ),
      _c(
        "v-flex",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabModel === "tab-4",
              expression: "tabModel === 'tab-4'"
            }
          ],
          attrs: { md12: "", sm12: "", xs12: "" }
        },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [_c("PreventivasDetalleGrid")],
            1
          )
        ],
        1
      ),
      _c(
        "v-flex",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabModel === "tab-5",
              expression: "tabModel === 'tab-5'"
            }
          ],
          attrs: { md12: "", sm12: "", xs12: "" }
        },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c("CorrectivasDetalleGrid", {
                attrs: { tabModel: _vm.tabModel }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }